import { Grid, GridItem } from "@chakra-ui/react"

export default function General(){

    return(
    <>
    <Grid templateColumns="33% 33% 33%">
        <GridItem>

        </GridItem>
    </Grid>
    </>
    )
}